import { useParams } from "react-router-dom"

export function UpdateTitle({ strId, initialTitle, hasCode, updateCallback, big = false, strType }) {
  const { tab } = useParams()

  const typeTag = strType == 2 ? 'Python' : 'MQL5'

  return (
    <div className={`block w-full mt-4 md:mt-0 mb-4 ${big ? 'big' : ''}`}>
      <div className="flex items-center justify-between gap-2">
        <span className="flex gap-3">
          <span className="font-medium text-2xl">{initialTitle}</span>
          <div className="flex items-center">
           <span className="inline-flex items-center px-3 py-1 rounded-lg bg-gray-300 text-gray-800 text-xs font-medium">{typeTag}</span>
          </div>
        </span>
      </div>
    </div>
  )

}
